import { Avatar } from "@maxhub/max-ui"

export const AvatarImageExample = {
    title: 'Avatar.Image',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'src',
            label: 'src',
            type: 'text',
            tsType: 'string',
            default: 'https://sun9-21.userapi.com/1N-rJz6-7hoTDW7MhpWe19e_R_TdGV6Wu5ZC0A/67o6-apnAks.jpg',
        },
        {
            name: 'alt',
            label: 'alt',
            type: 'text',
            tsType: 'string',
            default: 'Vadim Tregubenko',
        },
        {
            name: 'fallback',
            label: 'fallback',
            type: 'text',
            tsType: 'ReactNode',
            default: 'ME',
        },
        {
            name: 'fallbackGradient',
            label: 'fallbackGradient',
            type: 'enum',
            tsType: ['"custom"', '"red"', '"orange"', '"green"', '"blue"', '"purple"'],
            default: 'red',
            options: ['custom', 'red', 'orange', 'green', 'blue', 'purple'],
        },
    ],

    Preview({ props }){
        return (
            <div>
                <Avatar.Container form="circle">
                    <Avatar.Image
                        alt={props.alt}
                        fallback={props.fallback}
                        fallbackGradient={props.fallbackGradient}
                        src={props.src}
                        style={{objectFit:"cover"}}
                    />
                </Avatar.Container>
            </div>
        )
    },

    getCode(props){
        return `<Avatar.Container form="circle">
  <Avatar.Image
    alt="${props.alt}"
    fallback="${props.fallback}"
    fallbackGradient="${props.fallbackGradient}"
    src="${props.src}"
  />
</Avatar.Container>`
    }

}